import React from "react"
import Icon from "../Icon/Icon"

interface BuildPathDetailsProps {
	subtitle: string
	features: string[]
}

export default function BuildPathDetails({subtitle, features}: BuildPathDetailsProps) {
	return (
		<>
			<p className="build-path-details-option-subtitle">{subtitle}</p>
			<ul className="build-path-details-option-features">
				{features.map((text, index) => (
					<li className="feature-item" key={index}>
						<Icon icon="approve-v-check-validation" size={20} />
						<span>{text}</span>
					</li>
				))}
			</ul>
		</>
	)
}
